import MunicipalitiesWidget from './MunicipalitiesWidget';
export default MunicipalitiesWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/MunicipalitiesWidget/index.js